import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import enDashboard from './locales/en/dashboard.json';
import enDepartments from './locales/en/departments.json';
import enStaff from './locales/en/staff.json';
import enReports from './locales/en/reports.json';
import enSettings from './locales/en/settings.json';
import enAuth from './locales/en/auth.json';
import enVacation from './locales/en/vacation.json';
import enSchedule from './locales/en/schedule.json';
import enSickLeave from './locales/en/sickLeave.json'; 

import deCommon from './locales/de/common.json';
import deDashboard from './locales/de/dashboard.json';
import deDepartments from './locales/de/departments.json';
import deStaff from './locales/de/staff.json';
import deReports from './locales/de/reports.json';
import deSettings from './locales/de/settings.json';
import deAuth from './locales/de/auth.json';
import deVacation from './locales/de/vacation.json';
import deSchedule from './locales/de/schedule.json';
import deSickLeave from './locales/de/sickLeave.json'; 

const resources = {
  en: {
    common: enCommon,
    dashboard: enDashboard,
    departments: enDepartments,
    staff: enStaff,
    reports: enReports,
    settings: enSettings,
    auth: enAuth,
    vacation: enVacation,
    schedule: enSchedule,
    sickLeave: enSickLeave, 
  },
  de: {
    common: deCommon,
    dashboard: deDashboard,
    departments: deDepartments,
    staff: deStaff,
    reports: deReports,
    settings: deSettings,
    auth: deAuth,
    vacation: deVacation,
    schedule: deSchedule,
    sickLeave: deSickLeave, 
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    }
  });

export default i18n;